import React, { ReactNode } from 'react';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import {
  Element,
  HTMLReactParserOptions,
  domToReact,
} from 'html-react-parser';
import {
  MarkdownAdmonition,
  MarkdownAdmonitionBody,
  MarkdownAdmonitionHeader,
  MarkdownAdmonitionIcon,
  MarkdownAdmonitionTitle,
} from '../../../../Markdown/styles';
import {
  findChildElementByClassName,
  getElementChildNodes,
} from './documentationDomNodeUtils';

type DocumentationCalloutVariant =
  | 'warning'
  | 'tip'
  | 'danger'
  | 'info';

const calloutDefaultTitle: Record<
  DocumentationCalloutVariant,
  string
> = {
  warning: 'Warning',
  tip: 'Tip',
  danger: 'Danger',
  info: 'Info',
};

const calloutIconByVariant: Record<
  DocumentationCalloutVariant,
  ReactNode
> = {
  warning: <WarningIcon fontSize="small" />,
  tip: <WhatshotIcon fontSize="small" />,
  danger: <FlashOnIcon fontSize="small" />,
  info: <InfoIcon fontSize="small" />,
};

export function renderGhostCallout(
  domElement: Element,
  parserOptions: HTMLReactParserOptions,
) {
  const className = domElement.attribs?.class ?? '';
  const calloutVariant = getCalloutVariantFromClassName(className);
  const calloutTextElement = findChildElementByClassName(
    domElement,
    'kg-callout-text',
  );
  const calloutBodyNodes = domToReact(
    getElementChildNodes(calloutTextElement ?? domElement),
    parserOptions,
  );

  return (
    <MarkdownAdmonition data-variant={calloutVariant}>
      <MarkdownAdmonitionHeader data-variant={calloutVariant}>
        <MarkdownAdmonitionIcon data-variant={calloutVariant}>
          {calloutIconByVariant[calloutVariant]}
        </MarkdownAdmonitionIcon>
        <MarkdownAdmonitionTitle>
          {calloutDefaultTitle[calloutVariant]}
        </MarkdownAdmonitionTitle>
      </MarkdownAdmonitionHeader>
      <MarkdownAdmonitionBody>
        {calloutBodyNodes}
      </MarkdownAdmonitionBody>
    </MarkdownAdmonition>
  );
}

function getCalloutVariantFromClassName(
  className: string,
): DocumentationCalloutVariant {
  if (className.includes('red') || className.includes('pink')) {
    return 'danger';
  }

  if (className.includes('yellow') || className.includes('orange')) {
    return 'warning';
  }

  if (className.includes('green')) {
    return 'tip';
  }

  return 'info';
}
